module.exports = __webpack_public_path__ + "img/dialog-icon.d325da8e.png";